export const STATE_STORAGE_KEYS = {
  FORGE_BALANCES_STATE: 'FORGE_BALANCES_STATE',
  FORGE_USER_CONFIG_STATE: 'FORGE_USER_CONFIG_STATE',
  FORGE_METADATA_STATE: 'FORGE_METADATA_STATE',
  FORGE_VERSION_STATE: 'FORGE_VERSION_STATE'
}
